import { Cell } from '../grid/Cell'
import { BaseModal } from './BaseModal'
import { ImInfo } from 'react-icons/im'


type Props = {
  isOpen: boolean
  handleClose: () => void
}

export const InfoModal = ({ isOpen, handleClose }: Props) => {
  return (
  <BaseModal title="வழிமுறை" isOpen={isOpen} handleClose={handleClose}>
 
 <div className="flex justify-center mb-1 mt-4 text-2xl text-gray-500 dark:text-gray-300">
விளையாட்டு விதிகள். </div>

<div className="flex justify-center mb-1 text-sm text-gray-500 dark:text-gray-300">
5 எழுத்து சொல்லைக் கண்டுபிடிக்க வேண்டும்.<br />
6 முயற்சிகளுக்கு வாய்ப்பு அளிக்கப்படும்.<br />
முயன்ற சொல்லிலுள்ள எழுத்தின் நிறம் மாறும். 
</div>
      
      <div className="flex justify-center mb-1 mt-4">
        <Cell isRevealing={true} isCompleted={true} value="அ" status="correct" />
        <Cell isRevealing={true} isCompleted={true} value="ச்" status="present" />
        <Cell isRevealing={true} isCompleted={true} value="ச" status="present" />
        <Cell isRevealing={true} isCompleted={true} value="க" status="absent" />
        <Cell isRevealing={true} isCompleted={true} value="ம்" status="correct" />
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-300">
      <b>அ,ம்</b> எழுத்துகள் சரியான இடத்தில் உள்ளன. <br />
      <b>ச்,ச</b> எழுத்துகள் தவறான இடத்தில் உள்ளன. <br />
      <b>க</b> எழுத்து எந்த இடத்திலும் இல்லை.
      </p>

      <div className="flex justify-center mb-1 mt-4">
      <Cell isRevealing={true} isCompleted={true} value="அ" status="correct" />
      <Cell isRevealing={true} isCompleted={true} value="ணி" status="correct" />
      <Cell isRevealing={true} isCompleted={true} value="ச்" status="correct" />
      <Cell isRevealing={true} isCompleted={true} value="ச" status="correct" />
      <Cell isRevealing={true} isCompleted={true} value="ம்" status="correct" />

      </div>
      <p className="text-sm text-gray-500 dark:text-gray-300">
      எழுத்துகள் அனைத்தும் சரியான இடத்தில் உள்ளன. சொல்லாடல் வெற்றி!
      </p>
      
      <div className="flex justify-center mb-1 mt-4 text-2xl text-gray-500 dark:text-gray-300">
 <ImInfo></ImInfo>&nbsp;எழுத்து குறிப்பு விசை
</div>

<p className="flex justify-center text-sm text-gray-500 dark:text-gray-300">
சொல்லின் முதல் எழுத்தை அறியலாம். <br />
உயிர், மெய் எழுத்து எண்ணிக்கை வழங்கப்படும். <br />
வல்லினம், இடையினம், மெல்லினம் காணப்படும்.
      </p>

      <hr className="mt-3"></hr>

      <p className="mt-2 italic text-lg text-gray-500 dark:text-gray-300">
      நாள்தோறும் புதிய சொல்லாடல் !
      </p>
    </BaseModal>
  )
}
